if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form.product_add_form');
      this.s_form = this.querySelector('form.swatch_add_form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (this.s_form) this.s_form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.submitButton.closest('.product-form__buttons').addEventListener('mouseenter', this.showMsgBox.bind(this));
      this.submitButton.closest('.product-form__buttons').addEventListener('mouseleave', this.removeMsgBox.bind(this));
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    get msgBox() {
      return document.getElementById('msg');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      let submitButton = evt.target.querySelector('[type="submit"]');
      if (evt.target.classList.contains('product_add_form') && submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      evt.target.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(evt.target);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            submitButton.setAttribute('aria-disabled', true);
            submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            //console.log("response: " + JSON.stringify(response));
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) submitButton.removeAttribute('aria-disabled');
          evt.target.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    showMsgBox(evt) {
      this.checkValidate();
      const addButtonText = this.querySelector('[name="add"] > span');
      if (this.msgBox) {
        this.submitButton.setAttribute('disabled', true);
        let postion = this.getOffset();
        this.msgBox.style.left = postion.left + this.submitButton.offsetWidth + 15 + "px";
        this.msgBox.style.top = postion.top + 2 + "px";
        this.msgBox.style.display = "block";
      } else if (addButtonText.textContent == window.variantStrings.addToCart && this.submitButton.hasAttribute('disabled')) {
        this.submitButton.removeAttribute('disabled');
      }
    }

    checkValidate() {
      const sizeArr = Array.from(document.querySelectorAll('input[name="Size"]'));
      if (sizeArr.length == 0) return;
      const selectSize = sizeArr.find(item => item.checked);
      if (!selectSize) return this.createMsgBox(false);
      if (selectSize.value == 'Custom Size') return this.createMsgBox();
    }

    removeMsgBox() {
      const addButtonText = this.querySelector('[name="add"] > span');
      if (this.msgBox) this.msgBox.remove();
      if (addButtonText.textContent == window.variantStrings.addToCart && this.submitButton.hasAttribute('disabled')) {
        this.submitButton.removeAttribute('disabled');
      }
    }

    createMsgBox(sizeSelect = true) {
      let html = sizeSelect ? this.msgContentTwo() : this.msgContentOne();
      if (html) this.insertAdjacentHTML('beforeend', html);
    }

    msgContentOne() {
      let lists = '<div id="msg" class="msgSubmit2" style="top: 0; left: 0;"><em></em><div id="msg_con"><dl><dt>Please choose</dt><dd>';
      lists += "<p>Size</p>";
      lists += "</dd></dl></div></div>";
      return lists;
    }

    msgContentTwo() {
      const inputFiels = {
        options_206678_text: "Bust",
        options_206679_text: "Waist",
        options_206680_text: "Hips",
        options_206681_text: "Hollow to floor",
        options_210955_text: "Height (barefoot)",
        return_support_checkbox: "Custom size notice"
      };
      const arr = Object.keys(inputFiels);
      let lists = '<div id="msg" class="msgSubmit2" style="top: 0; left: 0;"><em></em><div id="msg_con"><dl><dt>Please choose</dt><dd>';
      let count = 0;
      for(let elem of arr) {
        let element = document.getElementById(elem);
        if (!element) {
          lists += `<p>${inputFiels[elem]}</p>`;
          count++;
          continue;
        }
        if(element.type == 'number' && element.value == "") {
          lists += `<p>${inputFiels[elem]}</p>`;
          count++;
        }
        if(element.type == 'checkbox' && !element.checked) {
          lists += `<p>${inputFiels[elem]}</p>`;
          element.closest('.return_support_notice').classList.add('error');
          count++;
        }
        if(element.type == 'checkbox' && element.checked) {
          element.closest('.return_support_notice').classList.remove('error');
        }
      }
      lists += "</dd></dl></div></div>";
      return count == 0 ? undefined : lists;
    }

    getOffset() {
      const rect = this.submitButton.getBoundingClientRect();
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
      };
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}